<template>
    <v-dialog v-model="editorShownMeeting" width="850" persistent>
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 1px solid indigo;">
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-user-friends"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Meetings List -------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: indigo; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/Meetings:</strong></div>
            <selected-meetings-list v-model="employees" v-if="editorShownMeeting" />

            <v-divider style="margin-top: 20px;"></v-divider>

            <!-- Selecting Meeting ----------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: indigo; padding-right: 10px;" class="b-fa b-fa-user-friends"></i><strong>Build your Meeting:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Meeting - from:" disabled="false" disabledTime="false" ref="startTimer" />
                <datetime v-model="endDate" label="Meeting - to:" disabled="false" disabledTime="false" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <airports-combo v-model="aptCode" label="Select Arprt:" />
                    </v-col>
                </v-row>

                <comment-textarea v-model="dutyComment" label="Meeting Info:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiEvents('MEETING').length }} Meetings(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_MeetingDialog">Close</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_MeetingUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>



        <!-- Begin:Content:Mode:create ------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 1px solid indigo;">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-user-friends"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Employees List ----------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: indigo; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownMeeting" />

            <v-divider style="margin-top: 0px;"></v-divider>

            <!-- Selecting Meeting ----------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: indigo; padding-right: 10px;" class="b-fa b-fa-user-friends"></i><strong>Build your Meeting:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Meeting - from:" disabled="false" disabledTime="false" ref="startTimer" />
                <datetime v-model="endDate" label="Meeting - to:" disabled="false" disabledTime="false" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <airports-combo v-model="aptCode" label="Select Arprt:" />
                    </v-col>
                </v-row>

                <comment-textarea v-model="dutyComment" label="Meeting Info:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiResources.length }} Employee(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_MeetingDialog">Close</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_MeetingCreate">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import AirportsCombo from '../../AirportsCombo.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import SelectedMeetingsList from '../../SelectedMeetingsList.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-meeting',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownMeeting
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            AirportsCombo,
            CommentTextarea,
            SelectedMeetingsList,
            SelectedEmployeesList,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            idApt           : null, // gets set in: 'get_AirportId'
            aptCode         : null,
            dutyComment     : null,
            employees       : [],
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_selectedMultiEvents', // get: selected Events
                'get_selectedMultiResources', // get: selected Resources
                'get_Airports',
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownDayoff()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownMeeting: {

                /***************************************************************
                * get()
                *
                * Note: Distinguishes between editorMode: 'update', 'create'
                * Note: Set '23:59' to Create endDate.
                *
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/meeting/EventEditor.vue >>> editorShownMeeting get');
                    if (me.value === true) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    idApt           : eventRecord.idApt,
                                    aptCode         : eventRecord.aptCode,
                                    dutyComment     : eventRecord.dutyComment
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    idApt           : null,
                                    aptCode         : null,
                                    dutyComment     : null
                                });
                            }
                        }

                    } else if (me.value === false) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo fumction ditorShownMeeting get()

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                *
                */
                set(value) {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/meeting/EventEditor.vue >>> editorShownMeeting set');
                    this.$emit('input', value);

                } // eo editorShownMeeting set()

            } // eo function editorShownMeeting()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to 'updatemeeting'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> created');
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker (not used right now)

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_SelectedMultiEvents',
                'actn_create_Multiple_Duty', // Call: Create multiple Duty
                'actn_update_Multiple_Duty' // Call: Update multiple Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_MeetingUpdate()
            *
            * Desc: 'Update Meeting(s)' - Call.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_MeetingUpdate: function() {

                let me = this,
                    singleParamObject = {},
                    params = {
                        breaks : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> onSave_MeetingUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        id: employee.originalId,
                        idResource: employee.resourceId,
                        from: moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        to: moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        type: 'MEETING',
                        status: 'PLANNED',
                        idApt: this.get_AirportId(me.aptCode),
                        dutyComment: me.dutyComment !== '' ? me.dutyComment : null
                    };
                    params.breaks.push(singleParamObject);
                });

                if (this.validateParams_Update(params) === true) {
                    this.actn_update_Multiple_Duty(params);
                }

            }, // eo function onSave_MeetingUpdate()


            /*******************************************************************
            * onSave_MeetingCreate()
            *
            * Desc: 'Create Meeting(s)' - Call.
            * Note:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_MeetingCreate: function() {

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> onSave_MeetingCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id: null,
                    // idResource: this.resourceRecord.id,
                    idResources : this.employees,
                    from: moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    to: moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    type: 'MEETING',
                    status: 'PLANNED',
                    idApt: this.get_AirportId(me.aptCode),
                    dutyComment: me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    this.actn_create_Multiple_Duty(params);
                    this.actn_set_SelectedMultiEvents([]); // send empty Array
                }

            }, // eo function onSave_MeetingCreate()


            /*******************************************************************
            * onClose_MeetingDialog()
            *
            * Desc: Close Meeting Dialog.
            * Note: Reset 'all selected Events' here.
            *
            */
            onClose_MeetingDialog: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> onClose_MeetingDialog');
                this.actn_set_SelectedMultiEvents([]); // send empty Array, #244
                me.editorShownMeeting = false;

                eventBus.$emit('schedulerdeselectall'); // #401

            }, // eo function onClose_MeetingDialog()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value) {

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> onChange_DatePicker');
                // newDate = new Date(value);
                // newDate.setHours(23);
                // newDate.setMinutes(59);
                // me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams_Update()
            *
            * Desc: Validate Params before Update.
            * Note:
            *
            * @param {Object} params (Params we want to send (update))
            */
            validateParams_Update: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> validateParams_Update');
                // >>> -------------------------- 'resources?'                  // Check 1
                if (params.breaks.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Ressources is a required field.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------


                // >>> -------------------------- 'startDate bef endDate?'      // Check 2
                if (valid === true) {  // still valid
                    startDate = moment(params.breaks[0].from);
                    endDate = moment(params.breaks[0].to);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                return valid;

            }, // eo function validateParams_Update()


            /*******************************************************************
            * validateParams()
            *
            * Desc: Checks/Validates Params before send to Backend.
            * Note: Kind if cascading Validations.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> validateParams');
                // >>> -------------------------- 'startDate bef endDate?'      // Check 1
                startDate = moment(params.from);
                endDate = moment(params.to);
                if (endDate.isBefore(startDate)) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: EndDate must be after StartDate.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------


                return valid;

            }, // eo function validateParams()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_AirportId()
            *
            * Desc: Return Airports ID.
            * Note:
            *
            */
            get_AirportId: function(code) {

                let me = this,
                    aptId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/meeting/EventEditor.vue >>> get_AirportId');
                this.get_Airports.forEach((apt, i) => {
                    if (apt.aptCode === code) {
                        this.idApt = apt.idAirport;
                        aptId = apt.idAirport;
                    }
                });


                return aptId;

            } // eo function get_AirportId()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
